import React, {Component} from 'react';
import { Link} from 'react-router-dom';

import LogoImage from "../../pages/pageParts/logo";
import {SlideUpDown} from "../../api/sliderConfig";

class Footer extends Component {

    componentDidMount(){
        var contentwidth = window.innerWidth;
        if ((contentwidth) < 750) {
            SlideUpDown('footer-title');
        } else {
            var elems = document.querySelectorAll(".footer-title");
            [].forEach.call(elems, function(elemt) {
                let el = elemt.nextElementSibling;
                el.style = "display: block";
            });
        }
    }

    render () {

        return (
                <footer className="footer-light pet-layout-footer">
                    <div className="white-layout">
                        <div className="container ">
                            <section className="small-section">
                                <div className="row footer-theme2">
                                    <div className="col">
                                        <div className="footer-link link-white">
                                            <div className="footer-brand-logo">
                                                <LogoImage />
                                            </div>
                                            <div className="social-white">
                                                <ul>
                                                    <li>
                                                        <a href='https://www.facebook.com/AmericanSpeechDebate' target="_blank" rel="noopener noreferrer" alt="facebook link"><i className="fa fa-facebook" aria-hidden="true"></i> </a>
                                                    </li>
                                                    <li>
                                                        <a href='https://www.instagram.com/american.speech.and.debate/' target="_blank" rel="noopener noreferrer"  alt="insta link"><i className="fa fa-instagram" aria-hidden="true"></i> </a>
                                                    </li>
                                                    <li>
                                                        <a href='https://www.youtube.com/channel/UC7nzw5cksvsNxheqspgXTrQ' target="_blank" rel="noopener noreferrer"><i className="fa fa-youtube" aria-hidden="true"></i></a>
                                                    </li>
{/*                                                    
                                                    <li>
                                                        <a href={'https://rss.com/'} target="_blank" rel="noopener noreferrer"><i className="fa fa-rss" aria-hidden="true"></i></a>
                                                    </li>
*/}                                                    
                                                </ul>
                                            </div>
                                            <div className="footer-title footer-mobile-title">
                                                <h4>Shortcuts</h4>
                                            </div>
                                            <div className="footer-contant">
                                                <ul>
                                                    <li className="detailAttribute"><Link to={`${process.env.PUBLIC_URL}/`} >home</Link></li>
                                                    <li className="detailAttribute"><Link to={`${process.env.PUBLIC_URL}/pages/lifaq`} >FAQ</Link></li>
                                                    <li className="detailAttribute"><Link to={`${process.env.PUBLIC_URL}/pages/contact`} >contact us</Link></li>
                                                    <li className="detailAttribute"><Link to={`${process.env.PUBLIC_URL}/pages/policies`} >Privacy, Terms, and Conditions</Link></li>                                                    
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                    <div className="sub-footer black-subfooter">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xl-6 col-md-6 col-sm-12">
                                    <div className="footer-end">
                                        <p><i className="fa fa-copyright" aria-hidden="true"></i> 2020 powered by Heather Lynn Designs</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
        );
    }
}

export default Footer;